import React from 'react';
import styled from 'styled-components';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';

const { Pagination } = Table;
const StyledTablePagination = styled(Pagination)`
  padding: 20px 0 !important;
  a {
    color: #8e8e93 !important;
    border-bottom: none !important;
  }
  .rs-pagination-btn-active > a {
    color: #34c3ff !important;
  }
`;

const TablePagination = ({
  page,
  total,
  limit,
  onChangePage,
  onChangeLimit
}) => (
  <StyledTablePagination
    activePage={page}
    total={total}
    lengthMenu={[
      {
        value: 20,
        label: 20
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ]}
    displayLength={limit}
    onChangePage={onChangePage}
    onChangeLength={onChangeLimit}
  />
);

TablePagination.propTypes = {
  page: PropTypes.number,
  limit: PropTypes.number,
  total: PropTypes.number,
  onChangePage: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired
};

TablePagination.defaultProps = {
  page: 1,
  limit: 20,
  total: 20
};

export default TablePagination;
